import React from 'react';
import Typography from '@material-ui/core/Typography';
import { marginStyles, StyledMiddleContent } from './styles';

interface MiddleContentProps {
    topNode?: JSX.Element;
    superHeading?: JSX.Element;
    heading: string | undefined;
    subHeading?: string;
    className?: string;
    maxWidth?: number;
    children:
        | React.ReactChild
        | React.ReactChild[]
        | React.ReactNode
        | React.ReactNode[];
    disableAnimation?: boolean;
}

const MiddleContent: React.FC<MiddleContentProps> = ({
    topNode,
    superHeading,
    heading,
    subHeading,
    children,
    maxWidth,
    className,
    disableAnimation,
}) => {
    const { marginY3, marginY5 } = marginStyles();

    return (
        <StyledMiddleContent maxWidth={maxWidth || 900} className={className}>
            {topNode}
            <div className={disableAnimation ? '' : 'slide-in-animation'}>
                {superHeading}
                {heading && (
                    <Typography variant="h2" className={`${marginY3} fs-unmask`}>
                        {heading}
                    </Typography>
                )}
                {subHeading && (
                    <Typography variant="subtitle2" className={`${marginY3} fs-unmask`}>
                        {subHeading}
                    </Typography>
                )}
                <div className={marginY5}>{children}</div>
            </div>
        </StyledMiddleContent>
    );
};

export default MiddleContent;
